import { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import UsersManagementTab from './_components/UsersManagementTab';
import RolesManagementTab from './_components/RolesManagementTab';
import TelegramIdsManagementTab from './_components/TelegramIdsManagementTab';
import WhatsAppNumbersManagementTab from './_components/WhatsAppNumbersManagementTab';
import OnlineModeManagementTab from './_components/OnlineModeManagementTab';
import GeneralManagementTab from './_components/GeneralManagementTab/GeneralManagementTab';

const ConfigurationsPage = () => {
  const [value, setValue] = useState('1');
  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, overflowX: 'auto', borderColor: 'divider' }}>
        <TabList
          onChange={handleChange}
          sx={{
            display: 'flex',
            minWidth: 'max-content',
          }}
        >
          <Tab label="Usuários" value="1" />
          <Tab label="Cargos" value="2" />
          <Tab label="Telegram" value="3" />
          <Tab label="WhatsApp" value="4" />
          <Tab label="Modo Online" value="5" />
          <Tab label="Geral" value="6" />

        </TabList>
      </Box>
      <TabPanel value="1">
        <UsersManagementTab />
      </TabPanel>
      <TabPanel value="2">
        <RolesManagementTab />
      </TabPanel>
      <TabPanel value="3">
        <TelegramIdsManagementTab />
      </TabPanel>
      <TabPanel value="4">
        <WhatsAppNumbersManagementTab />
      </TabPanel>
      <TabPanel value="5">
        <OnlineModeManagementTab />
      </TabPanel>
      <TabPanel value="6">
        <GeneralManagementTab /> {/* <-- Nova Aba */}
      </TabPanel>
    </TabContext>
  );
};

export default ConfigurationsPage;
